/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const drAlex = {
    mobileAnnouncement: function(){
        if (window.innerWidth <= 767) {
            const announcementContent = document.querySelector('.announcement-bar__content');
            if (!announcementContent){
                return;
            }
            announcementContent.innerText += " | " + announcementContent.innerText;
        }
    },
    announcementFade: function(){
        if (document.getElementById('announcement-bar-display-time')){
            const items = document.querySelectorAll(".announcement-bar__item");
            const displayTime = document.getElementById('announcement-bar-display-time').value;
            let currentIndex = 0;
            if (items.length === 0) return;
            items[currentIndex].classList.add("active");

            setInterval(() => {
                items[currentIndex].classList.remove("active");
                currentIndex = (currentIndex + 1) % items.length;
                items[currentIndex].classList.add("active");
            }, displayTime);

        }
    },
    priceSwitch: function(){
        const radios = document.querySelectorAll('input[name="purchaseOption"]');
        const secondaryPrice = document.querySelector('.secondary-price');

        if (!radios.length || !secondaryPrice) return;

        radios.forEach(radio => {
            radio.addEventListener('change', function () {
                if (this.checked) {
                    let priceText = '';

                    if (this.value === 'onetime') {
                        const label = this.closest('label')?.querySelector('.rc-radio__label');
                        if (label) {
                            const match = label.innerText.match(/[\d,]+\.\d{2}/);
                            priceText = match ? match[0] : '';
                        }
                    } else if (this.value === 'subscription') {
                        const price = this.closest('label')?.querySelector('.rc-radio__price');
                        if (price) {
                            const match = price.innerText.match(/[\d,]+\.\d{2}/);
                            priceText = match ? match[0] : '';
                        }
                    }

                    if (priceText) {
                        secondaryPrice.textContent = '$ ' + priceText;
                    }
                }
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', function(){
    drAlex.mobileAnnouncement();
    drAlex.announcementFade();

    if (document.body.classList.contains('template-product')) {
        setTimeout(() => {
            drAlex.priceSwitch();
        }, 1000);
    }
});

class AnimateSticky extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.onScrollHandler = this.onScroll.bind(this);

        window.addEventListener('scroll', this.onScrollHandler, false);
        this.onScrollHandler();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.getOffsetTop(this)) {
            window.requestAnimationFrame(this.reveal.bind(this));
        } else {
            window.requestAnimationFrame(this.reset.bind(this));
        }
    }

    reveal() {
        this.setAttribute('animate', '');
    }

    reset() {
        this.removeAttribute('animate');
    }

    getOffsetTop(element) {
        let offsetTop = 0;
        while(element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }
}
customElements.define('animate-sticky', AnimateSticky);
if (typeof jQuery !== 'undefined') {
    $(document).ready(function () {
        const bestSellerSlider = function () {
            if ($(window).width() < 768) {
                $('.bestsellers-list').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    infinite: true,
                    variableWidth: true,
                    mobileFirst: true,
                    prevArrow: '<button type="button" class="slick-prev"><svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<rect x="2.125" y="2.125" width="33.75" height="33.75" rx="16.875" stroke="#2333B0" stroke-width="3.75"/>\n' +
                        '<path d="M8.10401 17.675C7.75289 18.0266 7.55566 18.5031 7.55566 19C7.55566 19.4969 7.75289 19.9735 8.10401 20.325L15.174 27.3975C15.3482 27.5717 15.5549 27.7098 15.7825 27.8041C16.0101 27.8984 16.254 27.9469 16.5003 27.9469C16.7466 27.9469 16.9905 27.8984 17.218 27.8041C17.4456 27.7098 17.6523 27.5717 17.8265 27.3975C18.0007 27.2234 18.1388 27.0166 18.2331 26.789C18.3273 26.5615 18.3759 26.3176 18.3759 26.0713C18.3759 25.825 18.3273 25.5811 18.2331 25.3535C18.1388 25.126 18.0007 24.9192 17.8265 24.745L13.9565 20.875H28.3753C28.8725 20.875 29.3495 20.6775 29.7011 20.3259C30.0527 19.9742 30.2503 19.4973 30.2503 19C30.2503 18.5027 30.0527 18.0258 29.7011 17.6742C29.3495 17.3226 28.8725 17.125 28.3753 17.125H13.9565L17.8265 13.255C18.1781 12.9033 18.3755 12.4263 18.3754 11.929C18.3753 11.4316 18.1776 10.9547 17.8259 10.6031C17.4741 10.2516 16.9971 10.0541 16.4998 10.0542C16.0025 10.0544 15.5256 10.252 15.174 10.6038L8.10401 17.675Z" fill="#2333B0"/>\n' +
                        '</svg>\n</button>',
                    nextArrow: '<button type="button" class="slick-next"><svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<rect x="35.875" y="35.875" width="33.75" height="33.75" rx="16.875" transform="rotate(-180 35.875 35.875)" stroke="#2333B0" stroke-width="3.75"/>\n' +
                        '<path d="M29.896 20.325C30.2471 19.9734 30.4443 19.4969 30.4443 19C30.4443 18.5031 30.2471 18.0265 29.896 17.675L22.826 10.6025C22.6518 10.4283 22.4451 10.2902 22.2175 10.1959C21.9899 10.1016 21.746 10.0531 21.4997 10.0531C21.2534 10.0531 21.0095 10.1016 20.782 10.1959C20.5544 10.2902 20.3477 10.4283 20.1735 10.6025C19.9993 10.7766 19.8612 10.9834 19.7669 11.211C19.6727 11.4385 19.6241 11.6824 19.6241 11.9287C19.6241 12.175 19.6727 12.4189 19.7669 12.6465C19.8612 12.874 19.9993 13.0808 20.1735 13.255L24.0435 17.125L9.62474 17.125C9.12746 17.125 8.65054 17.3225 8.29891 17.6742C7.94728 18.0258 7.74974 18.5027 7.74974 19C7.74974 19.4973 7.94728 19.9742 8.29891 20.3258C8.65054 20.6774 9.12746 20.875 9.62474 20.875L24.0435 20.875L20.1735 24.745C19.8219 25.0967 19.6245 25.5737 19.6246 26.071C19.6247 26.5684 19.8224 27.0453 20.1741 27.3969C20.5259 27.7484 21.0029 27.9459 21.5002 27.9458C21.9975 27.9456 22.4744 27.748 22.826 27.3962L29.896 20.325Z" fill="#2333B0"/>\n' +
                        '</svg>\n</button>',
                    responsive:
                        [
                            {
                                breakpoint: 450,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            }
                        ]
                });
            } else {
                if ($('.bestsellers-list').hasClass('slick-initialized')) {
                  $('.bestsellers-list').slick('unslick');
                }
            }
        }
        bestSellerSlider();
        window.addEventListener('resize', bestSellerSlider);
    });
}
const QuickAdd = {
  // Tuning constants
  SUCCESS_REVERT_MS: 800,
  ERROR_VISIBLE_MS: 4000,
  DRAG_THRESHOLD_PX: 5,

  // Slick drag disambiguation state (QAA11Y-03)
  _pointerDownX: null,
  _pointerDownY: null,
  _draggedPastThreshold: false,

  init() {
    // Track pointer position at mousedown/touchstart to detect drags
    document.addEventListener('mousedown', (e) => {
      const btn = e.target.closest('[data-action="quick-add"]');
      if (!btn) return;
      QuickAdd._pointerDownX = e.clientX;
      QuickAdd._pointerDownY = e.clientY;
      QuickAdd._draggedPastThreshold = false;
    }, true);

    document.addEventListener('mousemove', (e) => {
      if (QuickAdd._pointerDownX === null) return;
      const dx = Math.abs(e.clientX - QuickAdd._pointerDownX);
      const dy = Math.abs(e.clientY - QuickAdd._pointerDownY);
      if (dx > QuickAdd.DRAG_THRESHOLD_PX || dy > QuickAdd.DRAG_THRESHOLD_PX) {
        QuickAdd._draggedPastThreshold = true;
      }
    }, true);

    // WR-01 fix: clear stale drag state on mouseup so abandoned drags
    // don't suppress the next genuine click
    document.addEventListener('mouseup', () => {
      QuickAdd._pointerDownX = null;
      QuickAdd._pointerDownY = null;
      // Defer reset so the click handler can still read the final drag state
      setTimeout(() => { QuickAdd._draggedPastThreshold = false; }, 0);
    }, true);

    document.addEventListener('touchstart', (e) => {
      const btn = e.target.closest('[data-action="quick-add"]');
      if (!btn || !e.touches[0]) return;
      QuickAdd._pointerDownX = e.touches[0].clientX;
      QuickAdd._pointerDownY = e.touches[0].clientY;
      QuickAdd._draggedPastThreshold = false;
    }, { capture: true, passive: true });

    document.addEventListener('touchmove', (e) => {
      if (QuickAdd._pointerDownX === null || !e.touches[0]) return;
      const dx = Math.abs(e.touches[0].clientX - QuickAdd._pointerDownX);
      const dy = Math.abs(e.touches[0].clientY - QuickAdd._pointerDownY);
      if (dx > QuickAdd.DRAG_THRESHOLD_PX || dy > QuickAdd.DRAG_THRESHOLD_PX) {
        QuickAdd._draggedPastThreshold = true;
      }
    }, { capture: true, passive: true });

    // Main click delegate
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-action="quick-add"]');
      if (!btn) return;

      const wasDrag = QuickAdd._draggedPastThreshold;
      QuickAdd._pointerDownX = null;
      QuickAdd._pointerDownY = null;
      QuickAdd._draggedPastThreshold = false;

      // QAA11Y-03: suppress click if the pointer was dragging
      if (wasDrag) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      // Sold out
      if (btn.disabled || btn.dataset.soldOut === 'true') {
        e.preventDefault();
        return;
      }

      // Multi-variant or selling-plan multi-variant → native PDP navigation (anchor tag)
      const variantCount = parseInt(btn.dataset.variantCount, 10);
      if (isNaN(variantCount) || variantCount > 1) {
        return;
      }

      // Single-variant fast path (QACOL-01)
      e.preventDefault();
      QuickAdd._addSingleVariant(btn);
    });

    // Initialize bar-specific event handlers
    QuickAdd._initBar();
  },

  _addSingleVariant(btn) {
    // In-flight guard (QACRT-04, T-06-03)
    if (btn.dataset.loading === 'true') return;
    btn.dataset.loading = 'true';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    const isBar = btn.closest('.quick-add-bar');
    btn.classList.add(isBar ? 'quick-add-bar--loading' : 'quick-add-pill--loading');

    const variantId = btn.dataset.variantId;
    // W5 fix — direct read, no aria-label parsing (robust against titles containing ": ")
    const productTitle = btn.dataset.productTitle || '';
    const cartAddUrl = (window.routes && window.routes.cartAddUrl)
      ? window.routes.cartAddUrl + '.js'
      : '/cart/add.js';

    // Read quantity from bar's qty stepper (defaults to 1 for pill path)
    const qtyEl = isBar && isBar.querySelector('.quick-add-bar__qty-value');
    const quantity = qtyEl ? Math.max(1, parseInt(qtyEl.textContent, 10) || 1) : 1;

    let wasSuccess = false;

    fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
      .then((res) => {
        if (res.status === 409) {
          return { __silent409: true };
        }
        if (res.status === 422) {
          return res.json().then((data) => { data.__422 = true; return data; });
        }
        if (!res.ok) {
          return { __error: 'network', __status: res.status };
        }
        return res.json();
      })
      .then((result) => {
        if (result && result.__silent409) {
          // QACRT-04: no UI change. Revert immediately (W4).
          QuickAdd._revertButton(btn);
          return;
        }
        if (result && result.__422) {
          QuickAdd._showInlineError(btn, 'Sorry, out of stock');
          QuickAdd._announce('Could not add ' + productTitle + ' to cart: out of stock');
          QuickAdd._revertButton(btn); // W4 — immediate revert on error
          return;
        }
        if (result && result.__error) {
          QuickAdd._showInlineError(btn, "Couldn't add \u2014 please try again");
          QuickAdd._announce('Could not add ' + productTitle + ' to cart: please try again');
          QuickAdd._revertButton(btn); // W4 — immediate revert on error
          return;
        }
        // Success (QACOL-01, QACRT-01, QACRT-05)
        wasSuccess = true;
        QuickAdd._showSuccessState(btn);
        QuickAdd._announce('Added ' + productTitle + ' to cart');
        QuickAdd._notifyCart(quantity);
      })
      .catch(() => {
        QuickAdd._showInlineError(btn, "Couldn't add \u2014 please try again");
        QuickAdd._announce('Could not add ' + productTitle + ' to cart: please try again');
        QuickAdd._revertButton(btn); // W4 — immediate revert on network error
      })
      .finally(() => {
        // W4: only use the 800ms timer on success so the checkmark is visible.
        if (wasSuccess) {
          setTimeout(() => {
            QuickAdd._revertButton(btn);
          }, QuickAdd.SUCCESS_REVERT_MS);
        }
        // Error paths have already called _revertButton directly.
      });
  },

  _revertButton(btn) {
    btn.dataset.loading = 'false';
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    btn.classList.remove('quick-add-pill--loading', 'quick-add-pill--success', 'quick-add-bar--loading', 'quick-add-bar--success');
  },

  _showSuccessState(btn) {
    btn.classList.remove('quick-add-pill--loading', 'quick-add-bar--loading');
    const isBar = btn.closest('.quick-add-bar');
    btn.classList.add(isBar ? 'quick-add-bar--success' : 'quick-add-pill--success');
  },

  _showInlineError(btn, message) {
    // WR-05 fix: scope error dedup to the product card, not btn.parentNode
    const card = btn.closest('.product-item');
    const errorSel = card ? '.quick-add-pill__error, .quick-add-bar__error' : '.quick-add-pill__error';
    const existing = (card || btn.parentNode).querySelector(errorSel);
    if (existing) existing.remove();

    const isBar = btn.closest('.quick-add-bar');
    const err = document.createElement('div');
    err.className = isBar ? 'quick-add-bar__error' : 'quick-add-pill__error';
    err.setAttribute('role', 'alert');
    err.textContent = message;
    const insertParent = isBar || btn.parentNode;
    insertParent.appendChild(err);

    setTimeout(() => {
      if (err && err.parentNode) err.remove();
    }, QuickAdd.ERROR_VISIBLE_MS);
  },

  _announce(message) {
    const live = document.getElementById('quick-add-live-region');
    if (!live) return;
    // Clear first so repeated identical messages re-trigger SR announcement
    live.textContent = '';
    setTimeout(() => { live.textContent = message; }, 50);
  },

  _notifyCart(quantity) {
    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: { quantity: quantity || 1 }
    }));
  },

  // ---------------------------------------------------------------------------
  // Bar-specific handlers (Plan 06-02)
  // ---------------------------------------------------------------------------

  _initBar() {
    // Bar ATC click handler — SEPARATE from pill delegate (data-action="quick-add")
    // Uses data-action="quick-add-bar" to avoid double-firing risk (RESEARCH.md Pattern 6)
    document.addEventListener('click', (e) => {
      const barAtcBtn = e.target.closest('[data-action="quick-add-bar"]');
      if (barAtcBtn) {
        e.preventDefault();
        e.stopPropagation();

        // Drag guard — reuse existing threshold check from QuickAdd.init()
        if (QuickAdd._draggedPastThreshold) return;

        // In-flight guard
        if (barAtcBtn.dataset.loading === 'true') return;

        // Read variant ID from bar's dropdown state (the currently selected option)
        // For single-variant products, data-variant-id on the button is already correct.
        // For multi-variant, JS updates data-variant-id on dropdown selection (_onVariantSelect).
        const variantId = barAtcBtn.dataset.variantId;

        if (!variantId) return;

        // Check if variant is available (button might be disabled for sold-out variant)
        if (barAtcBtn.disabled || barAtcBtn.getAttribute('aria-disabled') === 'true') return;

        // Delegate to existing _addSingleVariant() — reuses all 422/409/network handling
        // Temporarily set data-variant-count="1" to pass the existing guard in _addSingleVariant
        barAtcBtn.dataset.variantCount = '1';
        QuickAdd._addSingleVariant(barAtcBtn);
        return;
      }

      // Dropdown trigger toggle
      const trigger = e.target.closest('[data-action="toggle-dropdown"]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        QuickAdd._toggleDropdown(trigger);
        return;
      }

      // Dropdown option selection
      const option = e.target.closest('.quick-add-bar__dropdown-list [role="option"]');
      if (option) {
        e.preventDefault();
        e.stopPropagation();
        if (option.getAttribute('aria-disabled') === 'true') return;
        QuickAdd._onVariantSelect(option);
        return;
      }

      // Qty decrease
      const decBtn = e.target.closest('[data-action="qty-decrease"]');
      if (decBtn) {
        e.preventDefault();
        QuickAdd._adjustQty(decBtn, -1);
        return;
      }

      // Qty increase
      const incBtn = e.target.closest('[data-action="qty-increase"]');
      if (incBtn) {
        e.preventDefault();
        QuickAdd._adjustQty(incBtn, 1);
        return;
      }

      // Outside click — close all open dropdowns
      if (!e.target.closest('.quick-add-bar__dropdown')) {
        QuickAdd._closeAllDropdowns();
      }
    });

    // Keyboard navigation for dropdowns
    document.addEventListener('keydown', (e) => {
      const dropdown = e.target.closest('.quick-add-bar__dropdown');
      if (!dropdown) return;

      const list = dropdown.querySelector('.quick-add-bar__dropdown-list');
      const trigger = dropdown.querySelector('[data-action="toggle-dropdown"]');
      const isOpen = list && !list.hasAttribute('hidden');

      if (e.key === 'Escape') {
        if (isOpen) {
          list.setAttribute('hidden', '');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
          e.preventDefault();
        }
        return;
      }

      if (e.key === 'Enter' || e.key === ' ') {
        if (e.target === trigger && !isOpen) {
          QuickAdd._toggleDropdown(trigger);
          e.preventDefault();
          return;
        }
        // Select focused option
        const focused = list && list.querySelector('[role="option"]:focus');
        if (focused && focused.getAttribute('aria-disabled') !== 'true') {
          QuickAdd._onVariantSelect(focused);
          trigger.focus();
          e.preventDefault();
        }
        return;
      }

      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && isOpen) {
        e.preventDefault();
        const options = Array.from(list.querySelectorAll('[role="option"]'));
        const current = list.querySelector('[role="option"]:focus');
        let idx = options.indexOf(current);
        if (e.key === 'ArrowDown') {
          idx = idx < options.length - 1 ? idx + 1 : 0;
        } else {
          idx = idx > 0 ? idx - 1 : options.length - 1;
        }
        options[idx].focus();
        return;
      }
    });
  },

  _toggleDropdown(trigger) {
    const list = trigger.nextElementSibling;
    if (!list) return;
    const isOpen = !list.hasAttribute('hidden');

    // Close all other open dropdowns first
    QuickAdd._closeAllDropdowns();

    if (!isOpen) {
      list.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
      // Make options focusable
      list.querySelectorAll('[role="option"]').forEach(function(o) { o.setAttribute('tabindex', '-1'); });
      // Focus the currently selected option (or first option)
      const selected = list.querySelector('[aria-selected="true"]') || list.querySelector('[role="option"]');
      if (selected) selected.focus();
    } else {
      list.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }
  },

  _closeAllDropdowns() {
    document.querySelectorAll('.quick-add-bar__dropdown-list:not([hidden])').forEach(function(list) {
      list.setAttribute('hidden', '');
      const trigger = list.previousElementSibling;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  },

  _onVariantSelect(option) {
    const card = option.closest('.product-item');
    const bar = option.closest('.quick-add-bar');
    if (!bar || !card) return;

    const variantId = option.dataset.variantId;
    const available = option.dataset.available === 'true';

    // Update ATC button variant ID (bar ATC uses data-action="quick-add-bar")
    const atcBtn = bar.querySelector('[data-action="quick-add-bar"]');
    if (atcBtn) {
      atcBtn.dataset.variantId = variantId;
      if (!available) {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
      } else {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
      }
    }

    // Update aria-selected on all options
    const listbox = option.closest('[role="listbox"]');
    listbox.querySelectorAll('[role="option"]').forEach(function(o) {
      o.setAttribute('aria-selected', o === option ? 'true' : 'false');
    });

    // Update dropdown label and close
    const label = bar.querySelector('.quick-add-bar__dropdown-label');
    // Strip "(Sold Out)" suffix for label display
    var optText = option.textContent.replace(/\s*\(.*\)\s*$/, '').trim();
    if (label) label.textContent = optText;
    var closeTrigger = bar.querySelector('[data-action="toggle-dropdown"]');
    if (closeTrigger) closeTrigger.setAttribute('aria-expanded', 'false');
    if (listbox) listbox.setAttribute('hidden', '');

    // Price update (D-10)
    QuickAdd._updateCardPrice(card, variantId);

    // Image swap (D-11)
    QuickAdd._swapCardImage(card, variantId);
  },

  _updateCardPrice(card, variantId) {
    var jsonEl = card.querySelector('.quick-add-bar__variants-json');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variant = variants.find(function(v) { return String(v.id) === String(variantId); });
    if (!variant) return;

    var priceList = card.querySelector('.product-item__price-list');
    if (!priceList) return;

    var fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
    var formatMoney = function(cents) {
      if (typeof Currency !== 'undefined' && Currency.formatMoney) {
        return Currency.formatMoney(cents, fmt);
      }
      return fmt.replace('{{amount}}', (cents / 100).toFixed(2))
                .replace('{{amount_no_decimals}}', Math.round(cents / 100))
                .replace('{{amount_with_comma_separator}}', (cents / 100).toFixed(2).replace('.', ','));
    };

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceList.innerHTML =
        '<span class="price price--highlight"><span class="visually-hidden">' + (window.languages && window.languages.productSalePrice || 'Sale price') + '</span>' + formatMoney(variant.price) + '</span>' +
        '<span class="price price--compare"><span class="visually-hidden">' + (window.languages && window.languages.productRegularPrice || 'Regular price') + '</span>' + formatMoney(variant.compare_at_price) + '</span>';
    } else {
      priceList.innerHTML =
        '<span class="price"><span class="visually-hidden">' + (window.languages && window.languages.productSalePrice || 'Sale price') + '</span>' + formatMoney(variant.price) + '</span>';
    }
  },

  _swapCardImage(card, variantId) {
    var jsonEl = card.querySelector('.quick-add-bar__variants-json');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variant = variants.find(function(v) { return String(v.id) === String(variantId); });
    if (!variant || !variant.featured_image || !variant.featured_image.src) return;

    var img = card.querySelector('.product-item__primary-image');
    if (!img) return;

    var newSrc = variant.featured_image.src;

    // Handle lazysizes: if image has lazyloaded, update src directly; always update data-src
    if (img.classList.contains('lazyloaded')) {
      img.setAttribute('src', newSrc);
    }
    img.setAttribute('data-src', newSrc.replace(/(\.\w+)(\?|$)/, '_{width}x$1$2'));
    // Also update srcset if lazysizes uses data-srcset
    if (img.hasAttribute('data-srcset')) {
      img.setAttribute('data-srcset', '');
    }
    // Re-trigger lazysizes if available
    if (window.lazySizes) {
      img.classList.remove('lazyloaded');
      img.classList.add('lazyload');
    }
  },

  _adjustQty(btn, delta) {
    var stepper = btn.closest('.quick-add-bar__qty-stepper');
    if (!stepper) return;
    var valEl = stepper.querySelector('.quick-add-bar__qty-value');
    if (!valEl) return;
    var current = parseInt(valEl.textContent, 10) || 1;
    var next = Math.max(1, current + delta);
    valEl.textContent = next;

    // Enable/disable minus button at qty=1
    var minusBtn = stepper.querySelector('.quick-add-bar__qty-btn--minus');
    if (minusBtn) {
      minusBtn.disabled = next <= 1;
    }
  }
};

/* ===== PDP Add-to-Cart Capture Interceptor ===== */
// Deterministically beats native form submit and Rebuy's own listener by
// intercepting in the capture phase. Preserves Recharge selling_plan and
// line-item properties via FormData. Falls back to native submit on error.
const PdpAddToCart = {
  _bound: false,
  REBUY_WAIT_MS: 5000,   // max wait for lazy Rebuy SmartCart to mount before /cart fallback
  REBUY_POLL_MS: 150,

  init() {
    // Idempotent — guard against double-binding
    if (PdpAddToCart._bound) return;
    PdpAddToCart._bound = true;

    // Capture phase: fires before bubble-phase listeners (including Rebuy's)
    document.addEventListener('submit', PdpAddToCart._onSubmit, true);

    // Pre-warm Rebuy on product pages so SmartCart is mounted before the tap.
    PdpAddToCart._prewarmRebuy();
  },

  // The third-party deferrer (layout/theme.liquid) holds Rebuy until first user
  // interaction or 2.5s. On a product page an add is imminent — if the user's
  // FIRST interaction is the ADD TO CART tap, Rebuy starts cold at that moment
  // and races the REBUY_WAIT_MS fallback, intermittently landing on /cart
  // (observed on mobile). Release the deferrer early (after first paint, to
  // preserve LCP) so Rebuy boots + mounts SmartCart ahead of a realistic tap.
  // The deferrer listens once/capture on window for these events; dispatching
  // one is a harmless no-op when defer is bypassed/disabled or already released.
  _prewarmRebuy() {
    var isProduct = (window.theme && window.theme.pageType === 'product')
      || /\/products\//.test(window.location.pathname);
    if (!isProduct) return;
    var warm = function() {
      try { window.dispatchEvent(new Event('scroll')); } catch (e) {}
    };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warm, { timeout: 1500 });
    } else {
      setTimeout(warm, 1200);
    }
  },

  _onSubmit(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    // Not a cart-add form — let it through untouched
    if (!form) return;

    // Bypass flag set by _nativeFallback — let the native submit proceed
    if (form.dataset.pdpBypass === 'true') return;

    // In-flight guard: prevent double-tap double-add (T-lyj-02)
    if (form.dataset.adding === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    // Intercept: kill native submit AND stop Rebuy's own submit/click handler
    e.preventDefault();
    e.stopImmediatePropagation();

    form.dataset.adding = 'true';

    // The button that triggered the submit (e.submitter) — so the success state
    // lands on the actual tapped button (main or sticky). Fall back to the first
    // submit button in the form. Briefly disabled to swallow double taps.
    const submitBtn = e.submitter || form.querySelector('[type="submit"], button:not([type="button"]):not([type="reset"])');
    if (submitBtn) submitBtn.disabled = true;

    // Build request — FormData auto-captures id, quantity, selling_plan,
    // and line-item properties. Do NOT set Content-Type; browser sets the
    // multipart boundary for FormData automatically. This differs from
    // QuickAdd which sends JSON; FormData is required here to preserve
    // Recharge selling_plan/properties.
    const formData = new FormData(form);
    const addUrl = (window.routes && window.routes.cartAddUrl
      ? window.routes.cartAddUrl
      : '/cart/add') + '.js';

    // Derive quantity for product:added event (default 1)
    const quantity = parseInt(formData.get('quantity'), 10) || 1;

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function(res) {
        if (!res.ok) {
          // Non-ok response (e.g. 422 out of stock) — fall back to native POST.
          // The item was NOT added, so re-submitting is correct.
          PdpAddToCart._nativeFallback(form);
          return null;
        }
        return res.json();
      })
      .then(function(addResult) {
        if (!addResult) return; // fallback already triggered (item not added)

        // INSTANT feedback: badge + brief "Added" state, button freed right away.
        // The user is never blocked waiting on the drawer.
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { quantity: quantity }
        }));
        PdpAddToCart._showSuccess(form, submitBtn);

        // Open the Rebuy drawer in the BACKGROUND, the moment SmartCart is ready
        // (usually immediate thanks to the PDP pre-warm). Non-blocking: no freeze
        // and no forced /cart redirect — if Rebuy never mounts, the item is still
        // in the cart and the badge reflects it.
        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function(cartRes) { return cartRes.json(); })
          .then(function(cart) { PdpAddToCart._openRebuyWhenReady(cart); })
          .catch(function() {});
      })
      .catch(function() {
        // Network error — item NOT added; native fallback so user is never trapped
        PdpAddToCart._nativeFallback(form);
      });
  },

  // Try to open the Rebuy SmartCart drawer with the freshest cart.
  // Returns true ONLY if the drawer was actually shown.
  _tryOpenRebuy(cart) {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      try {
        if (typeof window.Rebuy.SmartCart.setCart === 'function') {
          window.Rebuy.SmartCart.setCart(cart);
        }
        window.Rebuy.SmartCart.show();
        return true;
      } catch (e) {
        return false;
      }
    }
    return false;
  },

  // Brief "Added" state so the add reads as instant, then frees the button so
  // the user is never blocked on the drawer. Restores the original label
  // (preserves the sticky button's price span) after a short beat. Clears the
  // in-flight guard immediately so a later legitimate add isn't blocked.
  _showSuccess(form, submitBtn) {
    if (form) form.dataset.adding = 'false';
    if (!submitBtn || submitBtn.dataset.pdpReverting === 'true') return;
    var original = submitBtn.innerHTML;
    submitBtn.dataset.pdpReverting = 'true';
    submitBtn.classList.add('is-added');
    submitBtn.innerHTML = 'Added ✓';
    setTimeout(function() {
      submitBtn.innerHTML = original;
      submitBtn.classList.remove('is-added');
      submitBtn.disabled = false;
      submitBtn.dataset.pdpReverting = 'false';
    }, 1200);
  },

  // Open the Rebuy drawer the moment SmartCart is available — non-blocking.
  // With the PDP pre-warm this is usually instant. Polls in the background up to
  // REBUY_WAIT_MS; if Rebuy never mounts it simply stops (no redirect, no freeze)
  // — the item is already in the cart and the badge reflects it.
  _openRebuyWhenReady(cart) {
    if (PdpAddToCart._tryOpenRebuy(cart)) return;
    var waited = 0;
    var poll = setInterval(function() {
      if (PdpAddToCart._tryOpenRebuy(cart)) { clearInterval(poll); return; }
      waited += PdpAddToCart.REBUY_POLL_MS;
      if (waited >= PdpAddToCart.REBUY_WAIT_MS) { clearInterval(poll); }
    }, PdpAddToCart.REBUY_POLL_MS);
  },

  // Sets the bypass flag and re-submits natively. Called ONLY on error /
  // non-ok response paths — NEVER after a successful AJAX add (that path
  // waits for the drawer / redirects to cart to avoid double-adding). T-lyj-02.
  _nativeFallback(form) {
    form.dataset.pdpBypass = 'true';
    form.submit();
  }
};

// Race #2 (260622-d9q): arm the capture-phase submit interceptor the instant
// custom.js executes, ahead of the dom-ready event. The listener targets
// `document` in capture phase — no DOM-parse dependency — and `_prewarmRebuy`
// only reads window.theme/location + dispatches a scroll event via idle/timeout,
// both safe before dom-ready. Closes the ~1s early-tap native-submit window
// observed between script parse and dom-ready on product pages.
PdpAddToCart.init();

/* ADA Fixes */
document.addEventListener('DOMContentLoaded', function () {
    QuickAdd.init();
    PdpAddToCart.init(); // defense-in-depth no-op: _bound guard makes this idempotent
});

/* ===== Ingredient Label Lightbox ===== */
// WR-01: track trigger element so focus can be restored on close
let _lightboxTrigger = null;

function _closeLightbox(overlay) {
  overlay.classList.remove('is-open');
  document.body.style.overflow = '';
  if (_lightboxTrigger) {
    _lightboxTrigger.focus();
    _lightboxTrigger = null;
  }
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-action="open-ingredient-label"]');
  const overlay = document.getElementById('ingredient-label-overlay');
  if (trigger && overlay) {
    _lightboxTrigger = trigger;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // WR-01: move focus to close button so keyboard/SR users can interact
    const closeBtn = overlay.querySelector('[data-action="close-ingredient-label"]');
    if (closeBtn) closeBtn.focus();
    return;
  }
  if (overlay && overlay.classList.contains('is-open')) {
    const isCloseBtn = e.target.closest('[data-action="close-ingredient-label"]');
    const isBackdrop = e.target === overlay;
    if (isCloseBtn || isBackdrop) _closeLightbox(overlay);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const overlay = document.getElementById('ingredient-label-overlay');
    if (overlay && overlay.classList.contains('is-open')) {
      _closeLightbox(overlay);
    }
  }
});

/* Pagination Scroll-Up */
document.addEventListener('click', function (event) {
    const target = event.target.closest('.pagination__nav-item, .pagination__prev, .pagination__next');
    if (target) {
        const collection = document.querySelector('.collection');
        if (collection) {
            collection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
});

/* ===== Brand Filter Search (Phase 7) ===== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.filter-brand-search').forEach(function (input) {
    var list = input.closest('.collection__filter-collapsible')
      .querySelector('[data-brand-filter-list]');
    if (!list) return;

    var items = list.querySelectorAll('.collection__filter-checkbox[data-brand-label]');

    input.addEventListener('input', function () {
      var query = input.value.trim().toLowerCase();

      if (!query) {
        /* Show everything when search is cleared */
        items.forEach(function (li) { li.removeAttribute('hidden'); });
        return;
      }

      items.forEach(function (li) {
        var label = li.getAttribute('data-brand-label') || '';
        if (label.indexOf(query) !== -1) {
          li.removeAttribute('hidden');
        } else {
          li.setAttribute('hidden', '');
        }
      });
    });
  });
});

